function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { DataMap } from './dataMapping';
import { getTrimmedWords } from './../utils/stringUtils';
import { Constants } from './constants';
const getAllCategoriesReferences = ()=>{
    return Object.values(DataMap.categories).map((category)=>Object.values(category)).flat();
};
const createBackendKeysFromSubCategories = (subCategories)=>{
    return Object.values(subCategories).reduce((acc, curr)=>{
        var _curr_BackendKey;
        if (!((_curr_BackendKey = curr.BackendKey) === null || _curr_BackendKey === void 0 ? void 0 : _curr_BackendKey.length)) return acc;
        // Create an entry for each backend key
        const entries = curr.BackendKey.reduce((keyAcc, key)=>_object_spread_props(_object_spread({}, keyAcc), {
                [key]: curr
            }), {});
        return _object_spread({}, acc, entries);
    }, {});
};
const getAllChildKeys = ({ SubCategoryDataMapping, BackendKey })=>{
    if (!SubCategoryDataMapping) return {};
    return Object.values(SubCategoryDataMapping).filter(({ UrlKey })=>UrlKey !== 'all' && (BackendKey === null || BackendKey === void 0 ? void 0 : BackendKey.length) && SubCategoryDataMapping.all).reduce((acc, curr)=>{
        var _curr_BackendKey, _SubCategoryDataMapping_all_BackendKey;
        if (!((_curr_BackendKey = curr.BackendKey) === null || _curr_BackendKey === void 0 ? void 0 : _curr_BackendKey.length) || !((_SubCategoryDataMapping_all_BackendKey = SubCategoryDataMapping.all.BackendKey) === null || _SubCategoryDataMapping_all_BackendKey === void 0 ? void 0 : _SubCategoryDataMapping_all_BackendKey.length)) return acc;
        // Map each backend key to all parent backend keys
        const entries = curr.BackendKey.reduce((keyAcc, childKey)=>{
            const parentEntries = SubCategoryDataMapping.all.BackendKey.reduce((parentAcc, parentKey)=>_object_spread_props(_object_spread({}, parentAcc), {
                    [childKey]: parentKey
                }), {});
            return _object_spread({}, keyAcc, parentEntries);
        }, {});
        return _object_spread({}, acc, entries);
    }, {});
};
const createAllChildMap = (categories)=>{
    return categories.filter(({ BackendKey, SubCategoryDataMapping })=>{
        var _SubCategoryDataMapping_all_BackendKey, _SubCategoryDataMapping_all;
        return (BackendKey === null || BackendKey === void 0 ? void 0 : BackendKey.length) && (SubCategoryDataMapping === null || SubCategoryDataMapping === void 0 ? void 0 : (_SubCategoryDataMapping_all = SubCategoryDataMapping.all) === null || _SubCategoryDataMapping_all === void 0 ? void 0 : (_SubCategoryDataMapping_all_BackendKey = _SubCategoryDataMapping_all.BackendKey) === null || _SubCategoryDataMapping_all_BackendKey === void 0 ? void 0 : _SubCategoryDataMapping_all_BackendKey.length);
    }).reduce((acc, { BackendKey, SubCategoryDataMapping })=>{
        // Create mappings for each combination of parent and child backend keys
        const entries = BackendKey.reduce((keyAcc, key)=>{
            const parentEntries = SubCategoryDataMapping.all.BackendKey.reduce((parentAcc, parentKey)=>_object_spread_props(_object_spread({}, parentAcc), {
                    [key]: parentKey
                }), {});
            return _object_spread({}, keyAcc, parentEntries);
        }, {});
        return _object_spread({}, acc, entries);
    }, {});
};
export const categoryKeyByBackendKey = Object.assign({}, ...getAllCategoriesReferences().map(({ SubCategoryDataMapping })=>{
    return SubCategoryDataMapping ? createBackendKeysFromSubCategories(SubCategoryDataMapping) : {};
}));
export const industryKeyByBackendKey = Object.assign({}, ...Object.values(DataMap.industries).map(({ SubCategoryDataMapping })=>createBackendKeysFromSubCategories(SubCategoryDataMapping)));
export const cloudIndustryKeyByBackendKey = Object.assign({}, ...Object.values(DataMap.cloudIndustries).map(({ SubCategoryDataMapping })=>createBackendKeysFromSubCategories(SubCategoryDataMapping)));
export const productKeyByUrlKey = Object.keys(DataMap.products).reduce((acc, curr)=>_object_spread_props(_object_spread({}, acc), {
        [DataMap.products[`${curr}`].UrlKey]: curr
    }), {});
export const productKeyByBackendKey = Object.keys(DataMap.products).reduce((acc, curr)=>{
    var _product_BackendKey;
    const product = DataMap.products[`${curr}`];
    if (!((_product_BackendKey = product.BackendKey) === null || _product_BackendKey === void 0 ? void 0 : _product_BackendKey.length)) return acc;
    // Create an entry for each backend key
    const entries = product.BackendKey.reduce((keyAcc, key)=>_object_spread_props(_object_spread({}, keyAcc), {
            [key]: curr
        }), {});
    return _object_spread({}, acc, entries);
}, {});
const productKeyByBitmaskFilter = Object.keys(DataMap.products).reduce((acc, curr)=>{
    const { FilterGroup, FilterID } = DataMap.products[`${curr}`];
    return _object_spread_props(_object_spread({}, acc), {
        [`${FilterGroup}_${FilterID}`]: curr
    });
}, {});
const calculateShortCutBitmask = (productInfo)=>{
    const { ShortcutFilters, FilterGroup, FilterID } = productInfo || {};
    return (ShortcutFilters === null || ShortcutFilters === void 0 ? void 0 : ShortcutFilters.length) ? ShortcutFilters.map((productKey)=>{
        return DataMap.products[`${productKey}`];
    }).reduce((currMask, shortcutProductInfo)=>{
        const { FilterGroup: currentFilterGroup, FilterID } = shortcutProductInfo;
        return _object_spread_props(_object_spread({}, currMask), {
            [currentFilterGroup]: currMask[`${currentFilterGroup}`] ? currMask[`${currentFilterGroup}`] | FilterID : FilterID
        });
    }, {
        [FilterGroup]: FilterID
    }) : {
        [FilterGroup]: FilterID
    };
};
const productShortcutBitmask = Object.keys(DataMap.products).reduce((acc, curr)=>_object_spread_props(_object_spread({}, acc), {
        [DataMap.products[`${curr}`].UrlKey]: calculateShortCutBitmask(DataMap.products[`${curr}`])
    }), {});
export const categoryAllChildMap = Object.assign({}, ...getAllCategoriesReferences().map((category)=>getAllChildKeys(category)).concat(createAllChildMap(getAllCategoriesReferences())));
export const industryAllChildMap = Object.assign({}, ...Object.values(DataMap.industries).map((industry)=>getAllChildKeys(industry)).concat(createAllChildMap(Object.values(DataMap.industries))));
export const cloudIndustryAllChildMap = Object.assign({}, ...Object.values(DataMap.cloudIndustries).map((cloudIndustry)=>getAllChildKeys(cloudIndustry)).concat(createAllChildMap(Object.values(DataMap.cloudIndustries))));
export const allChildMaps = {
    [Constants.DataMapCollectionKeys.categories]: categoryAllChildMap,
    [Constants.DataMapCollectionKeys.products]: {},
    [Constants.DataMapCollectionKeys.industries]: industryAllChildMap,
    [Constants.DataMapCollectionKeys.cloudIndustries]: cloudIndustryAllChildMap,
    [Constants.DataMapCollectionKeys.serviceTypes]: {},
    [Constants.DataMapCollectionKeys.pricingModel]: {},
    [Constants.DataMapCollectionKeys.ratings]: {},
    [Constants.DataMapCollectionKeys.appCompliance]: {},
    [Constants.DataMapCollectionKeys.azureBenefitEligible]: {},
    [Constants.DataMapCollectionKeys.copilotExtension]: {},
    [Constants.DataMapCollectionKeys.productType]: {},
    [Constants.DataMapCollectionKeys.operatingSystem]: {},
    [Constants.DataMapCollectionKeys.publisher]: {}
};
export const addAllIdToChildCategory = ({ ids, collection })=>{
    return ids === null || ids === void 0 ? void 0 : ids.concat(ids.filter((id)=>allChildMaps[`${collection}`][`${id}`]).map((id)=>allChildMaps[`${collection}`][`${id}`]));
};
export const getShortCutBitmask = (productInfo)=>{
    const bitmask = productShortcutBitmask[`${productInfo.UrlKey}`];
    return bitmask;
};
const getUrlKeys = ({ collection })=>{
    return Object.keys(collection).reduce((urlKeys, currentDataValue)=>{
        return _object_spread_props(_object_spread({}, urlKeys), {
            [collection[`${currentDataValue}`].UrlKey]: true
        });
    }, {});
};
const getCategoryUrlKeys = ()=>{
    return _object_spread({}, getUrlKeys({
        collection: DataMap.categories.default
    }), getUrlKeys({
        collection: DataMap.categories.office
    }), getUrlKeys({
        collection: DataMap.categories.addIns
    }), getUrlKeys({
        collection: DataMap.categories.powerBiVisuals
    }));
};
export const urlKeys = {
    [Constants.DataMapCollectionKeys.categories]: getCategoryUrlKeys(),
    [Constants.DataMapCollectionKeys.products]: getUrlKeys({
        collection: DataMap.products
    }),
    [Constants.DataMapCollectionKeys.industries]: getUrlKeys({
        collection: DataMap.industries
    }),
    [Constants.DataMapCollectionKeys.serviceTypes]: getUrlKeys({
        collection: DataMap.serviceTypes
    }),
    [Constants.DataMapCollectionKeys.pricingModel]: getUrlKeys({
        collection: DataMap.pricingModel
    }),
    [Constants.DataMapCollectionKeys.operatingSystem]: getUrlKeys({
        collection: DataMap.operatingSystem
    }),
    [Constants.DataMapCollectionKeys.publisher]: getUrlKeys({
        collection: DataMap.publisher
    }),
    [Constants.DataMapCollectionKeys.ratings]: getUrlKeys({
        collection: DataMap.ratings
    }),
    [Constants.DataMapCollectionKeys.appCompliance]: getUrlKeys({
        collection: DataMap.appCompliance
    }),
    [Constants.DataMapCollectionKeys.azureBenefitEligible]: getUrlKeys({
        collection: DataMap.AzureBenefitEligible
    }),
    [Constants.DataMapCollectionKeys.copilotExtension]: getUrlKeys({
        collection: DataMap.CopilotExtension
    }),
    [Constants.DataMapCollectionKeys.productType]: getUrlKeys({
        collection: DataMap.productType
    }),
    [Constants.DataMapCollectionKeys.cloudIndustries]: getUrlKeys({
        collection: DataMap.cloudIndustries
    })
};
const getSubUrlKeys = ({ collection })=>{
    return Object.values(collection).filter((collection)=>collection.SubCategoryDataMapping).reduce((urlKeys, { SubCategoryDataMapping: currentSubCategoryKey })=>{
        const subUrlKeys = Object.fromEntries(Object.keys(currentSubCategoryKey).map((subCategoryKey)=>[
                currentSubCategoryKey[`${subCategoryKey}`].UrlKey,
                true
            ]));
        return _object_spread({}, urlKeys, subUrlKeys);
    }, {});
};
const getSubCategoryUrlKeys = ()=>{
    return Object.values(DataMap.categories).reduce((acc, collection)=>{
        return _object_spread({}, acc, getSubUrlKeys({
            collection
        }));
    }, {});
};
export const subUrlKeys = {
    [Constants.DataMapCollectionKeys.categories]: getSubCategoryUrlKeys(),
    [Constants.DataMapCollectionKeys.products]: getSubUrlKeys({
        collection: DataMap.products
    }),
    [Constants.DataMapCollectionKeys.industries]: getSubUrlKeys({
        collection: DataMap.industries
    }),
    [Constants.DataMapCollectionKeys.serviceTypes]: getSubUrlKeys({
        collection: DataMap.serviceTypes
    }),
    [Constants.DataMapCollectionKeys.pricingModel]: getSubUrlKeys({
        collection: DataMap.pricingModel
    }),
    [Constants.DataMapCollectionKeys.ratings]: getSubUrlKeys({
        collection: DataMap.ratings
    }),
    [Constants.DataMapCollectionKeys.operatingSystem]: getSubUrlKeys({
        collection: DataMap.operatingSystem
    }),
    [Constants.DataMapCollectionKeys.publisher]: getSubUrlKeys({
        collection: DataMap.publisher
    }),
    [Constants.DataMapCollectionKeys.appCompliance]: getSubUrlKeys({
        collection: DataMap.appCompliance
    }),
    [Constants.DataMapCollectionKeys.azureBenefitEligible]: getSubUrlKeys({
        collection: DataMap.AzureBenefitEligible
    }),
    [Constants.DataMapCollectionKeys.copilotExtension]: getSubUrlKeys({
        collection: DataMap.CopilotExtension
    }),
    [Constants.DataMapCollectionKeys.productType]: getSubUrlKeys({
        collection: DataMap.productType
    }),
    [Constants.DataMapCollectionKeys.cloudIndustries]: getSubUrlKeys({
        collection: DataMap.cloudIndustries
    })
};
export function bitMasksMatch(bitMasks, property, mask) {
    return !!(bitMasks && bitMasks[`${property}`] && (bitMasks[`${property}`] & mask) > 0);
}
export function bitMasksMatchBitMask(bitMasksA, bitMasksB) {
    return bitMasksMatch(bitMasksA, bitMasksB.property, bitMasksB.mask);
}
export function bitMasksMatchFilter(bitMasksA, filter) {
    return bitMasksMatch(bitMasksA, filter.FilterGroup, filter.FilterID);
}
export function bitMasksContainSomeBitMask(bitMasksA, bitMasksB) {
    for (const key of Object.keys(bitMasksA)){
        if (bitMasksB[`${key}`] && (bitMasksB[`${key}`] & bitMasksA[`${key}`]) > 0) {
            return true;
        }
    }
    return false;
}
export function getPrimaryProductUrl(primaryProduct) {
    if (primaryProduct) {
        var _DataMap_products_;
        const property = Object.keys(primaryProduct)[0];
        const mask = primaryProduct[`${property}`];
        const maskKey = `${property}_${mask}`;
        const productKey = productKeyByBitmaskFilter[`${maskKey}`];
        return (_DataMap_products_ = DataMap.products[`${productKey}`]) === null || _DataMap_products_ === void 0 ? void 0 : _DataMap_products_.UrlKey;
    }
}
export function getProductFilter(primaryProduct) {
    for (const key of Object.keys(primaryProduct)){
        for(const product in DataMap.products){
            if (DataMap.products[`${product}`].FilterID === primaryProduct[`${key}`] && DataMap.products[`${product}`].FilterGroup === key) {
                return DataMap.products[`${product}`];
            }
        }
    }
    return null;
}
export function getCategoryListByProductId(productBitMaskFilter, datamap) {
    if (!productBitMaskFilter || Object.keys(productBitMaskFilter).length === 0) {
        return DataMap.categories.default;
    }
    const productFilter = getProductFilter(productBitMaskFilter);
    if (productFilter !== null) {
        if (datamap) {
            return datamap.categories[productFilter.categoryList];
        }
        return DataMap.categories[productFilter.categoryList];
    }
    return null;
}
export function getCategoryListByListName(name, datamap) {
    if (datamap) {
        return datamap.categories[`${name}`];
    }
    return DataMap.categories[`${name}`];
}
const _DataMap_categories = DataMap.categories, { default: defaultCateogires } = _DataMap_categories, specificCategories = _object_without_properties(_DataMap_categories, [
    "default"
]);
export const overidedCategories = _object_spread({}, Object.values(specificCategories).reduce((acc, curr)=>_object_spread({}, curr, acc), {}), defaultCateogires);
export function removeUnmatchedCategories(query, newProductUrlKey, newProductFilterData) {
    const newQuery = {
        product: newProductUrlKey
    }; // product is required in output even if optional in type
    if (!query) {
        return newQuery;
    }
    const L1Product = newProductFilterData;
    const categoryListL1Product = getCategoryListByProductId(L1Product);
    const categories = query.category ? getTrimmedWords(query.category, ';') : [];
    let newCategory = '';
    for(const key in query){
        if (key === 'product') {
            continue;
        }
        if (key !== 'category') {
            newQuery[`${key}`] = query[`${key}`];
        } else {
            for(const queryCategory in categories){
                for(const category in categoryListL1Product){
                    if (category === categories[`${queryCategory}`]) {
                        newCategory += category + ';';
                        break;
                    }
                }
            }
        }
    }
    newCategory = newCategory !== '' ? newCategory.slice(0, -1) : newCategory;
    newQuery.category = newCategory !== '' ? newCategory : null;
    return newQuery;
}
export function countDataMapOffersForCollection({ items, collection }) {
    Object.values(collection).forEach((dataValue)=>{
        if (dataValue.match) {
            dataValue.count = items.some((item)=>dataValue.match(item)) ? 1 : 0;
        }
        if (dataValue.SubCategoryDataMapping) {
            Object.values(dataValue.SubCategoryDataMapping).forEach((subCategory)=>{
                if (subCategory.match) {
                    subCategory.count = items.some((item)=>subCategory.match(item)) ? 1 : 0;
                }
            });
        }
    });
}
export function countDataMapOffers({ items, dataMap, deepCopyDataMap, updateMatchFunctions }) {
    const counted = deepCopyDataMap(dataMap);
    updateMatchFunctions(counted);
    Object.entries(counted).forEach(([collectionKey, collection])=>{
        if (collectionKey === Constants.DataMapCollectionKeys.categories) {
            Object.values(collection).forEach((categoryCollection)=>countDataMapOffersForCollection({
                    items,
                    collection: categoryCollection
                }));
        } else {
            countDataMapOffersForCollection({
                items,
                collection: collection
            });
        }
    });
    const trimmed = deepCopyDataMap(counted);
    return trimmed;
}
